export default __webpack_public_path__ + "static/media/dunant-hosp.490d963e.png";